module.exports = __webpack_public_path__ + "img/teams-no-matching-results.31da83e3.svg";